import { TranslationLangaugeResource } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class TranslationsApi {
    async getTranslations(
        successCallback: (resources: TranslationLangaugeResource[]) => void,
        failureCallback: (error: string) => void
    ): Promise<void> {
        const dataUrl = '/api/translations';

        await new ApiHelper().getData(
            dataUrl,
            successCallback,
            failureCallback
        );
    }
}
